import { useContext } from 'react';
import VideoContext from '../context/VideoContext';
import Icon from './Icon';

export const VideoImage = ({ id = 'SZEflIVnhH8', img = '/images/demo6/dashboard-07.png', extraClass }) => {
    const { showVideo } = useContext(VideoContext);
    return (
        <>
            <button
                type="button"
                className={extraClass || 'video-btn video-btn-xl bg-orange-red ico-90'}
                onClick={() => showVideo(id)}
            >
                <Icon symbol="▶" decorative className="icon-play" />
            </button>
            <img className="img-fluid" src={img} alt="video-preview" />
        </>
    );
};

export const VideoWithBtn = ({ id = '7e90gBu4pas', extraClass, defText = 'See OLMO in Action' }) => {
    const { showVideo } = useContext(VideoContext);
    return (
        <button
            type="button"
            className={extraClass || 'video-popup2 btn btn-md btn-transparent ico-20 ico-left'}
            onClick={() => showVideo(id)}
        >
            <Icon symbol="▶" decorative className="icon-inline" />
            {defText}
        </button>
    );
};
